import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgMessage({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 20.674l.003-3.242C3.104 15.76 2 13.463 2 11c0-4.999 4.502-9 10-9s10 4.001 10 9c0 4.998-4.502 9-10 9-1.1 0-2.88.578-5.27 1.752A1.2 1.2 0 015 20.674zm2.001-1.26C9.09 18.474 10.742 18 12 18c4.443 0 8-3.162 8-7s-3.557-7-8-7-8 3.162-8 7c0 1.993.96 3.859 2.626 5.183l.378.3v.484L7 19.413zM7.5 12.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm4.5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm4.5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
        fill={color}
      />
    </svg>
  )
}

export default SvgMessage
